import React from "react"
import { Label, LabelProps } from "reactstrap"

interface FormLabelProps extends LabelProps {
  required?: boolean
}

const FormLabel: React.FC<FormLabelProps> = ({
  required,
  children,
  ...props
}) => {
  return (
    <div className="d-flex align-items-center justify-content-between">
      <Label className="form-label text-capitalize" {...props}>
        {children}
      </Label>
      {required && <span className="text-danger fw-bold font-size-16">*</span>}
    </div>
  )
}

export default FormLabel
